module.exports = __webpack_public_path__ + "img/12广东省政府采购代理机构行业自律公约成员单位.ebab428c.png";